// import { TweenMax, Power2, TimelineLite } from "gsap/TweenMax";
// import parallax from '../../plugins/parallax.js';

// parallax.init({
//   inertiaScrollSpeed: 0.3
// });